/**
 * Fait : l'écran de connexion — adresse, mot de passe, et le refus du serveur
 *   affiché TEL QUEL. Le message est le même pour une adresse inconnue, un
 *   mauvais mot de passe et un compte désactivé : le client ne rétablit pas
 *   l'oracle que le serveur a pris soin d'effacer.
 *
 * Ne fait pas : elle ne valide ni l'adresse ni le mot de passe — les bornes
 *   vivent dans les schémas partagés, et le serveur tranche. Un client qui
 *   validerait lui-même écrirait la règle une seconde fois.
 */

import { useState } from 'react';

import { Annonce } from '../gabarits/Annonce.tsx';
import { Champ } from '../gabarits/Champ.tsx';
import { Partie } from '../gabarits/Partie.tsx';
import { seConnecte } from './api.ts';

/** L'aide de l'écran, sortie du JSX pour tenir dans la largeur du code. */
const AIDE =
  'Votre adresse est celle à laquelle vous avez reçu votre invitation. Votre ' +
  'mot de passe, vous l’avez choisi en créant votre compte.';

export function PageConnexion({ surEntree }: { readonly surEntree: () => void }) {
  const [adresse, setAdresse] = useState('');
  const [motDePasse, setMotDePasse] = useState('');
  const [echec, setEchec] = useState<string | null>(null);
  const [enCours, setEnCours] = useState(false);

  /** Tente la connexion, et laisse le serveur dire non. */
  async function entre(evenement: React.FormEvent): Promise<void> {
    evenement.preventDefault();
    setEnCours(true);
    setEchec(null);

    const issue = await seConnecte(adresse, motDePasse);
    setEnCours(false);

    if (issue.bon) {
      surEntree();
      return;
    }

    setEchec(issue.erreur.message);
  }

  return (
    <div className="empilement" data-etat="nominal" data-ecran="connexion">
      <Partie
        etiquette="Votre atelier de famille"
        nature="projet"
        titre="Entrer dans l’atelier"
        niveauDeTitre={2}
        aide={AIDE}
        data-role="partie-connexion"
      >
        {echec !== null && (
          <Annonce urgence="urgent" nature="refus">
            {echec}
          </Annonce>
        )}

        <form onSubmit={(evenement) => void entre(evenement)}>
          <Champ
            libelle="Adresse électronique"
            name="adresse"
            type="email"
            autoComplete="username"
            value={adresse}
            onChange={(evenement) => setAdresse(evenement.target.value)}
          />
          <Champ
            libelle="Mot de passe"
            name="mot-de-passe"
            type="password"
            autoComplete="current-password"
            value={motDePasse}
            onChange={(evenement) => setMotDePasse(evenement.target.value)}
          />
          <button type="submit" data-role="principal" disabled={enCours}>
            {enCours ? 'Connexion…' : 'Entrer'}
          </button>
        </form>

        <p>
          <a href="#/oubli" data-role="vers-l-oubli">
            J’ai oublié mon mot de passe
          </a>
        </p>
      </Partie>
    </div>
  );
}
